import React, { useEffect, useRef } from 'react'
import "../styles/aboutPage.css"
import profileImage from "../assets/img/roarz1.jpg" // <-- replace with your actual image path
import { useNavigate } from 'react-router-dom';
import Nav from '../components/Nav';
import Footer from '../components/Footer';

const About = () => {
  const navigate = useNavigate();

   const servicesRef = useRef(null);
      
   useEffect (() => {
    const revealElements = servicesRef.current.querySelectorAll("[data-reveal]");
     const scrollReveal = () => {
        for (let i = 0; i < revealElements.length; i++) {
         const elementIsInScreen =
        revealElements[i].getBoundingClientRect().top < window.innerHeight / 1.15;
      
      if (elementIsInScreen) {
       revealElements[i].classList.add("revealed");
       } else {
          revealElements[i].classList.remove("revealed");
           }
        }
       };
      
       window.addEventListener("scroll", scrollReveal);
          scrollReveal(); // Initial check
      
          return () => {
            window.removeEventListener("scroll", scrollReveal);
          };
        }, []);

    const handleContactBtn = () => {
  navigate("/get-in-touch")
}

  return (
    <>
      <div className='home__wrapper' ref={servicesRef}>
      <Nav/>
        {/* === ABOUT SECTION === */}

        <section className="about__hero-section">
          <div className="about__hero-content">
            <div>
            <h1>
              We craft experiences <br />
              that move people <br />
             </h1>

            <p className="about__hero-subtext">
              Using design and technology to transform ideas into reality.
            </p>
            </div>


            <div className="about__hero-since">
              <h2 className="about__hero-since-left">(20</h2>
              <div className="about__hero-since-center">
                <p>Empowering<br />people since</p>
               </div>
              <h2 className="about__hero-since-right">20)</h2>
            </div>
          </div>
        </section>

<section className="about__page-section">
  <div className="about__page-content">
    <div className="about__page-text">
      <h1>Local Roots, Global Impact</h1>
      <p className="subtitle">
        A word from Eugene Ongeri, our Founder & Managing Director.
      </p>

      <p>
        I grew up in a self-employed family, where running a local business
        meant forging real connections and growing alongside our community.
      </p>

      <p>
        From the age of nine, I was captivated by the art of calligraphy, carefully crafting words into something meaningful. 
        By seventeen, I was diving into video editing, unknowingly nurturing the creative, people-centered mindset that now drives 
        everything we do at Roarz Kreatives, helping brands from local start-ups to global names tell their stories with purpose and artistry.
      </p>

      <p>
        Our mission is to help businesses thrive through creative, strategic
        marketing. We’re proud of the impact we’ve made, and we can’t wait
        to see what’s next.
      </p>

      <div className="about__page-signature">
        <p className="about__page-signature-text">Eugene Ongeri</p>
      </div>
    </div>

    <div className="about__page-image">
      <img src={profileImage} alt="Eugene Ongeri" />
    </div>
  </div>
</section>


        {/* === APPROACH SECTION === */}
        <section className="approach-section">
          <div className="approach-content">
            <div className="approach-header">
              <h4 data-reveal>Our approach</h4>
              <p data-reveal>Roarz Kreatives® Agency<br />since 2020</p>
            </div>

            <div className="approach-body">
              <h2 data-reveal>
                Our solutions are based on research and a deep understanding of trends,
                aimed at driving change, innovation in business, and improving people’s lives.
              </h2>
              <p className="approach-subtext" data-reveal>
                We act as a strategic partner, looking into the future and creating a foundation
                for growth and scalability.
              </p>
            </div>
          </div>
        <section className="values-section">
          <div className="values-content">
            <div className="values-header">
              <h4 data-reveal>Our main values</h4>
            </div>

            <div className="values-grid">
              <div className="value-item">
                <h2 data-reveal>Integrity</h2>
                <p data-reveal>Operate with honesty, transparency, and ethical practices, building trust with clients, partners, and employees.</p>
              </div>
              <div className="value-item">
                <h2 data-reveal>Innovation</h2>
                <p data-reveal>Embrace a culture of continuous improvement and stay ahead of industry trends by fostering creativity, exploring new technologies, and adapting to change.</p>
              </div>
              <div className="value-item">
                <h2 data-reveal>Excellence</h2>
                <p data-reveal>Strive for excellence in every aspect of work, setting high standards and continuously seeking ways to surpass them.</p>
              </div>
              <div className="value-item">
                <h2 data-reveal>Partnership</h2>
                <p data-reveal>Aim to create value that extends far beyond the immediate horizon, ensuring a partnership that grows stronger with each passing year.</p>
              </div>
            </div>
          </div>
        </section>

        </section>

        <section className="booking-wrapper" >
  <div className="booking-content">
    <h3 data-reveal>Let's get to work</h3>
    <p data-reveal>Ready to get started? Book a Discovery Call so we can learn more about your needs and discuss how we can help.</p>
    <button  className="get-started-btn" onClick={handleContactBtn}>
      Get Started <span className="plus-icon">+</span>
    </button>
  </div>
   
</section>


  <Footer/>
      </div>
    </>
  )
}

export default About
